import { logger } from "@origin-digital/reporting-client";
import spacetime, { Spacetime } from "spacetime";

enum WEEKDAYS {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
}

enum WEEKENDS {
  SATURDAY = 6,
  SUNDAY = 0,
}

const EVERYDAY = { ...WEEKDAYS, ...WEEKENDS };
const weekDays = Object.values(WEEKDAYS);
const weekEnds = Object.values(WEEKENDS);

const openingHours = [
  {
    days: weekDays,
    start: 7,
    end: 21,
  },
  {
    days: weekEnds,
    start: 8,
    end: 17,
  },
];

const timezone = "Australia/Sydney";

export const isTimeInRange = (day: number, time: number): boolean => {
  const hours = openingHours.find((hrs) => {
    const days = hrs.days as (number | string)[];
    return days.some((d) => d === day);
  });
  logger.debug(`Current day and time: ${EVERYDAY[day]} ${time}`);
  if (hours) {
    return time >= hours.start && time < hours.end;
  }
  return false;
};

export const checkLiveChatAvailability = (current?: Spacetime): boolean => {
  let date = current;
  if (!date) date = spacetime.now();

  const tzDate = date.goto(timezone);
  const day = tzDate.day();
  const time = tzDate.hour();
  return isTimeInRange(day, time);
};
